import React, { useState } from 'react';

import { useGetCourtsListQuery, } from 'features/courts';

import { CourtsTable } from './components/CourtsTable';

const defaultPageSize = 30;

const initParams = {
  page: 1,
  pageSize: defaultPageSize,
};

interface Props {
  handleCreateClick: () => void;
  handleEditClick: (courtId: number) => void;
}

export const CourtsTablePage = ({ handleCreateClick, handleEditClick }: Props) => {
  const [params, setParams] = useState(initParams);

  const {
    courtsList,
    courtsCount,
    isCourtsFetching,
  } = useGetCourtsListQuery(undefined, {
    selectFromResult: ({ data, isFetching }) => ({
      courtsList: data ?? [],
      courtsCount: data?.length ?? 0,
      isCourtsFetching: isFetching,
    })
  });

  const handlePaginationChange = (page: number, pageSize: number) => {
    setParams((prev) => ({
      ...prev,
      page,
      pageSize,
    }));
  };

  return (
    <div>
      <CourtsTable
        items={courtsList}
        itemsTotal={courtsCount}
        currentPage={params.page}
        defaultPageSize={defaultPageSize}
        onPageChange={handlePaginationChange}
        isLoading={isCourtsFetching}
        onEditClick={handleEditClick}
        onCreateClick={handleCreateClick}
      />
    </div>
  );
};
